import React, { useEffect } from 'react';

function TeamPage() {
  useEffect(() => {
    setTimeout(() => {
      if (window.WOW) {
        try {
          new window.WOW().init();
        } catch (e) {
          console.log('WOW.js not available');
        }
      }
    }, 500);
  }, []);

  const teamMembers = [
    {
      id: 1,
      name: 'Aleesha Charlotte',
      position: 'CEO Founder',
      image: 'assets/images/team/team-1-1.jpg',
      delay: '100ms'
    },
    {
      id: 2,
      name: 'David Michale',
      position: 'Therapist',
      image: 'assets/images/team/team-1-2.jpg',
      delay: '200ms'
    },
    {
      id: 3,
      name: 'Sarah Johnson',
      position: 'Counselor',
      image: 'assets/images/team/team-1-3.jpg',
      delay: '300ms'
    },
    {
      id: 4,
      name: 'Michael Brown',
      position: 'Psychiatrist',
      image: 'assets/images/team/team-1-4.jpg',
      delay: '100ms'
    },
    {
      id: 5,
      name: 'Emily Davis',
      position: 'Clinical Psychologist',
      image: 'assets/images/team/team-1-5.jpg',
      delay: '200ms'
    },
    {
      id: 6,
      name: 'James Wilson',
      position: 'Mental Health Specialist',
      image: 'assets/images/team/team-1-6.jpg',
      delay: '300ms'
    }
  ];

  return (
    <>
      {/* Page Header Start */}
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: 'url(/assets/images/backgrounds/slider-2-3.jpg)' }}></div>
        <div className="container">
          <div className="page-header__inner">
            <h2 className="page-header__title">Our Team</h2>
            <ul className="thm-breadcrumb">
              <li><a href="/">Home</a></li>
              <li><span>/</span></li>
              <li><span>Our Team</span></li>
            </ul>
          </div>
        </div>
      </section>
      {/* Page Header End */}

      {/* Team Page Start */}
      <section className="team-page">
        <div className="container">
          <div className="row">
            {teamMembers.map((member) => (
              <div key={member.id} className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={member.delay}>
                <div className="team-one__single">
                  <div className="team-one__img-box">
                    <div className="team-one__img">
                      <img src={member.image} alt={member.name} />
                    </div>
                    <div className="team-one__shape-1"></div>
                    <div className="team-one__name-box">
                      <h3>
                        <a href="/team">
                          <span>{member.name.split(' ')[0]}</span>
                          <br /> {member.name.split(' ')[1]}
                        </a>
                      </h3>
                    </div>
                    <div className="team-one__sub-title-and-share-btn">
                      <div className="team-one__sub-title">
                        <p>- {member.position}</p>
                      </div>
                      <div className="team-one__share-and-email">
                        <a href="/team"><span className="fa fa-share-alt"></span></a>
                        <a href="/contact"><span className="fa fa-envelope"></span></a>
                      </div>
                    </div>
                    <ul className="list-unstyled team-one__social">
                      <li><a href="https://twitter.com"><i className="fab fa-twitter"></i></a></li>
                      <li><a href="https://facebook.com"><i className="fab fa-facebook"></i></a></li>
                      <li><a href="https://pinterest.com"><i className="fab fa-pinterest-p"></i></a></li>
                      <li><a href="https://instagram.com"><i className="fab fa-instagram"></i></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Team Page End */}
    </>
  );
}

export default TeamPage;
